/* Hide empty native/BK summaries and empty review sections. Keep positive reviews visible. */
(() => {
  const selector = '.collection-star-section.bk-reviews, #auto-bk-star-section, #auto-bk-review-section';
  const ownedReviewAttribute = 'data-dc-owned-review';
  const reviewRequest = new URLSearchParams(window.location.search).get('avaliar') === '1';
  let reviewRequestFocused = false;

  if (reviewRequest) document.documentElement.classList.add('dc-review-request');

  function updateFallback(element, state) {
    const card = element.closest('product-card, .decolab-variant-card');
    if (card) {
      card.setAttribute(ownedReviewAttribute, state === 'positive' ? 'positive' : 'fallback');
      return;
    }

    if (element.id === 'auto-bk-star-section' || element.id === 'auto-bk-review-section') {
      document.documentElement.setAttribute(
        `${ownedReviewAttribute}-product`,
        state === 'positive' ? 'positive' : 'fallback'
      );
    }
  }

  function reviewCount(element) {
    if (!element) return null;
    const text = element.textContent.replace(/\s+/g, ' ').trim();
    const parenthesized = text.match(/\(\s*([\d.,]+)\s*(?:avaliaç(?:ão|ões)|reviews?)?\s*\)/i);
    if (element.id !== 'auto-bk-review-section' && parenthesized) {
      return Number(parenthesized[1].replace(/[.,]/g, ''));
    }
    const integer = /^(?:\d+|\d{1,3}(?:[.,]\d{3})+)$/;
    for (const node of element.querySelectorAll('*')) {
      if (node.childElementCount !== 0) continue;
      const value = node.textContent.trim();
      const inline = value.match(/^((?:\d+|\d{1,3}(?:[.,]\d{3})+))\s*avaliaç(?:ão|ões)(?:\s+globais)?$/i);
      if (inline) return Number(inline[1].replace(/[.,]/g, ''));
      if (/^avaliaç(?:ão|ões)$/i.test(value)) {
        const previous = node.previousElementSibling?.textContent.trim();
        if (previous && integer.test(previous)) return Number(previous.replace(/[.,]/g, ''));
      }
    }
    return null;
  }

  function update(element) {
    let count = reviewCount(element);
    if (count === null && element.id === 'auto-bk-review-section') {
      count = reviewCount(document.querySelector('#auto-bk-star-section'));
    }
    const state = count > 0 ? 'positive' : count === 0 ? 'empty' : 'pending';
    if (element.dataset.dcReviewCount !== state) element.dataset.dcReviewCount = state;
    updateFallback(element, state);
    if (element.id === 'auto-bk-star-section') {
      const section = document.querySelector('#auto-bk-review-section');
      if (section) update(section);
    }

    if (reviewRequest && element.id === 'auto-bk-review-section' && !reviewRequestFocused) {
      reviewRequestFocused = true;
      requestAnimationFrame(() => element.scrollIntoView({behavior: 'smooth', block: 'start'}));
    }
  }
  function scan(root) {
    if (root.nodeType !== 1) return;
    if (root.matches(selector)) update(root);
    root.querySelectorAll(selector).forEach(update);
    const summary = root.closest(selector);
    if (summary) update(summary);
  }
  scan(document.documentElement);
  new MutationObserver((changes) => {
    const roots = new Set();
    for (const change of changes) {
      roots.add(change.target.nodeType === 1 ? change.target : change.target.parentElement);
      change.addedNodes.forEach(node => { if (node.nodeType === 1) roots.add(node); });
    }
    roots.forEach(root => { if (root) scan(root); });
  }).observe(document.body, {childList:true, subtree:true, characterData:true});
})();
